/*
Author: Jeewantha Madubashana Karunarathna
Date: 07/04/2025
Copyright © 2025 Infix!. All rights reserved.
*/

import {Utility} from "@/utils";
import {useEffect,useState} from "react";

interface IInformationPackHtmlContent {
    htmlContent: string | undefined;
  }

const InformationPackHtmlContent:React.FC<IInformationPackHtmlContent>  = (props:IInformationPackHtmlContent) => {
    const {htmlContent } = props;
    const [html, setHtml] =  useState<string | undefined>();

    useEffect(()=>{
        if(htmlContent){
            setHtml(Utility.sanitizeContent(htmlContent))
        }
    }, [htmlContent]);
    return (
        <div>
        {html ? <div className="body-description" dangerouslySetInnerHTML={{ __html: html }} /> : null }
        </div>
    )
}

export default InformationPackHtmlContent;